exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Root___16YHd {\n  padding: 0.25rem;\n  user-select: none;\n  display: inline-flex;\n}\n\n.Root___16YHd *:not(:first-child) {\n  margin-left: 0.25rem;\n}\n", ""]);

// exports
exports.locals = {
	"Root": "Root___16YHd"
};